export function setCookie(name, value, expiration) {
	let expires = "";
	if (expiration) {
		const date = new Date();
		date.setTime(date.getTime() + (expiration*24*60*60*1000));
		expires = "; expires=" + date.toUTCString();
	}
	document.cookie = `${name}=${value || ""}${expires}; path=/`;
}

export function getCookie(name) {
	const cookieList = document.cookie.split(';');
	for(let i=0;i < cookieList.length;i++) {
		const cookie = cookieList[i];
		const [cookieName, cookieValue] = cookie.split("=");
		if (cookieName.trim() === name) {
			return cookieValue;
		}
	}
	return null;
}